import {OfferGhId, OfferRpId, PropertyGhId, PropertyKmId, PropertyRpId} from "../../../types/ids";

export type AmplitudeEventPropertyValue = string | number | null;
export type AmplitudeEventProperties = Record<string, AmplitudeEventPropertyValue>;

export interface IAmplitudeItemIdParams {
    itemId?: AmplitudeEventPropertyValue;
    offerId?: OfferRpId | OfferGhId;
    propertyId?: PropertyRpId | PropertyGhId | PropertyKmId;
}

export interface IAmplitudePropertyTrackingIdSource {
    id?: PropertyKmId | PropertyRpId;
    rp_id?: PropertyRpId | null;
    gh_id?: PropertyGhId | null;
    offer: {
        rp_id?: OfferRpId | null;
        gh_id?: OfferGhId | null;
    };
}

const firstDefinedId = <T extends number | string>(...candidates: (T | null | undefined)[]): T | undefined =>
    candidates.find((candidate): candidate is T => candidate != null);

/** Prefer RP ids, then GH, then KM/`id` — keeps `0` (unlike `||`). */
export const getAmplitudePropertyTrackingIds = (property: IAmplitudePropertyTrackingIdSource): Pick<IAmplitudeItemIdParams, "offerId" | "propertyId"> => ({
    offerId: firstDefinedId(property.offer.rp_id, property.offer.gh_id),
    propertyId: firstDefinedId(property.rp_id, property.gh_id, property.id)
});

export const getAmplitudeItemIdProperties = ({itemId, offerId, propertyId}: IAmplitudeItemIdParams): AmplitudeEventProperties => {
    const eventProperties: AmplitudeEventProperties = {};

    if (offerId != null) {
        eventProperties.item_id = itemId ?? offerId;
    } else if (itemId != null) {
        eventProperties.item_id = itemId;
    }

    if (propertyId != null) {
        eventProperties.property_id = propertyId;
    }

    return eventProperties;
};
import {OfferGhId, OfferRpId, PropertyGhId, PropertyKmId, PropertyRpId} from "../../../types/ids";

export type AmplitudeEventPropertyValue = string | number | null;
export type AmplitudeEventProperties = Record<string, AmplitudeEventPropertyValue>;

export interface IAmplitudeItemIdParams {
    itemId?: AmplitudeEventPropertyValue;
    offerId?: OfferRpId | OfferGhId;
    propertyId?: PropertyRpId | PropertyGhId | PropertyKmId;
}

export interface IAmplitudePropertyTrackingIdSource {
    id?: PropertyKmId | PropertyRpId;
    rp_id?: PropertyRpId | null;
    gh_id?: PropertyGhId | null;
    offer: {
        rp_id?: OfferRpId | null;
        gh_id?: OfferGhId | null;
    };
}

const firstDefinedId = <T extends number | string>(...candidates: (T | null | undefined)[]): T | undefined =>
    candidates.find((candidate): candidate is T => candidate != null);

/** Prefer RP ids, then GH, then KM/`id` — keeps `0` (unlike `||`). */
export const getAmplitudePropertyTrackingIds = (property: IAmplitudePropertyTrackingIdSource): Pick<IAmplitudeItemIdParams, "offerId" | "propertyId"> => ({
    offerId: firstDefinedId(property.offer.rp_id, property.offer.gh_id),
    propertyId: firstDefinedId(property.rp_id, property.gh_id, property.id)
});

export const getAmplitudeItemIdProperties = ({itemId, offerId, propertyId}: IAmplitudeItemIdParams): AmplitudeEventProperties => {
    const eventProperties: AmplitudeEventProperties = {};

    if (offerId != null) {
        eventProperties.item_id = itemId ?? offerId;
    } else if (itemId != null) {
        eventProperties.item_id = itemId;
    }

    if (propertyId != null) {
        eventProperties.property_id = propertyId;
    }

    return eventProperties;
};
